import React, { useContext, useEffect, useState } from "react";
import constants from "../../../constants";
import LeftArrowPagination from "../../../Svg/LeftArrowPagination";
import RightArrowPagination from "../../../Svg/RightArrowPagination";
import { MockTestPageContext } from "../../../context/MockTestPageContext";
import MockTestLibraryHooks from "../../../Hooks/Mock/Student/MockTestLibraryHooks";
import CompanySpecificTestDetailsHooks from "../../../Hooks/Mock/Student/CompanySpecificTestDetailsHooks";
import "../../../Sass/Layout/MockTestPage/Student/CompanySpecificLibrary.scss";
import CompanySpecificLibraryCards from "../MockTestPage/CompanySpecificLibraryCards";
import AlertContext from "../../../context/AlertContext";
const normalizeFeatureName = (feature) =>
  String(feature || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

export default function CompanySpecificLibrary() {
  const Alert = useContext(AlertContext);
  const companyId = parseInt(localStorage.getItem("companyId"), 10);
  const stored = localStorage.getItem("account_response");
  const [enabledFeatures, setEnableFeatures] = useState([]);

  useEffect(() => {
    MockTestPageCxt.setSearchText("");
    if (!stored) return;

    try {
      const decoded = JSON.parse(atob(stored));
      const companies = Array.isArray(decoded) ? decoded : [decoded];

      const selectedCompany = companies.find(
        (company) => company.company_id === companyId || company.id === companyId
      );

      if (selectedCompany && selectedCompany.premium_features) {
        const rawFeatures = selectedCompany.premium_features;
        const features =
          typeof rawFeatures === "string" ? JSON.parse(rawFeatures) : rawFeatures;

        if (Array.isArray(features)) {
          const enabled = features
            .map((feature) =>
              feature.premium_feature_name ??
              feature.premium_feature_label ??
              feature.name ??
              feature.premium_features
            )
            .filter(Boolean);

          setEnableFeatures(enabled);
          localStorage.setItem(
            "enabled_features",
            btoa(JSON.stringify(features))
          );
        }
      }
    } catch (error) {
      console.error("Error decoding account_response:", error);
    }
  }, [stored, companyId]);

  console.log(
    "\n\n\n\n----------Company Specific enabled features-------------\n\n\n\n",
    enabledFeatures
  );

  const MockTestPageCxt = useContext(MockTestPageContext);
  const MockTestLibraryHks = MockTestLibraryHooks();

  CompanySpecificTestDetailsHooks();

  const hasFeature = (featureName) =>
    enabledFeatures.includes(normalizeFeatureName(featureName));

  const canShowTest = (test) => {
    if (test.hasOwnProperty("toc")) return true;

    if (test.libtype === constants.libTypeIds.MCQ) {
      return hasFeature("mcq");
    }

    if (
      test.libtype === constants.libTypeIds.DESCRIPTIVE &&
      !test.aiMode &&
      !test.videoqn &&
      !test.autoeval
    ) {
      return hasFeature("descriptive");
    }

    if (test.libtype === constants.libTypeIds.CODING_CHALLENGE) {
      return hasFeature("coding_challenge_test");
    }

    if (test.libtype === constants.libTypeIds.CODING_SNIPPET) {
      return hasFeature("coding_snippet");
    }

    if (test.libtype === constants.libTypeIds.DESCRIPTIVE && test.videoqn) {
      return hasFeature("video_test");
    }

    return false;
  };

  const tests = MockTestPageCxt.searchMockTest.filter(canShowTest);
  if (!Alert.isLoaded && tests.length === 0) {
  return (
    <div className="mockTestLibraryMainContainer">
      <div className="mockTestNoResults">
        <div className="mockTestNoResultsIcon">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <path
              d="M14.667 25.3333C20.5579 25.3333 25.3337 20.5577 25.3337 14.6667C25.3337 8.77564 20.5579 4 14.667 4C8.77601 4 4.00033 8.77564 4.00033 14.6667C4.00033 20.5577 8.77601 25.3333 14.667 25.3333Z"
              stroke="#667085"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28.0003 28L22.2003 22.2"
              stroke="#667085"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h3>No tests found</h3>

        <p>
          {MockTestPageCxt.searchText
            ? `No tests match "${MockTestPageCxt.searchText}".`
            : "There are no tests available."}
        </p>
      </div>
    </div>
  );
}

  return (
    <div className="mockTestLibraryMainContainer">
      {tests.filter((test) => test.relevant).length > 0 && (
        <div className="mockTestsCardHolder">
          <p className="mockTestHeads">Relevant To You</p>
          {tests.filter((test) => test.relevant).length >= 3 && (
            <LeftArrowPagination
              onClick={() => MockTestLibraryHks.scroll("left", "relevant")}
            />
          )}
          <div 
            className="relevantMockTestContainer"
            ref={MockTestLibraryHks.mockTestRefs.relevant}
          >
            {tests
              .filter((test) => test.relevant)
              .map((test) => (
                <CompanySpecificLibraryCards key={test.id} test={test} />
              ))}
          </div>
          {tests.filter((test) => test.relevant).length >= 3 && (
            <RightArrowPagination
              onClick={() => MockTestLibraryHks.scroll("right", "relevant")}
            />
          )}
        </div>
      )}

      {tests.filter((test) => test.hasOwnProperty("toc")).length > 0 && (
        <div className="mockTestsCardHolder">
          <p className="mockTestHeads">Test Series</p>
          {tests.filter((test) => test.hasOwnProperty("toc")).length >= 3 && (
            <LeftArrowPagination
              onClick={() => MockTestLibraryHks.scroll("left", "group")}
            />
          )}
          <div
            className="groupMockTestContainer"
            ref={MockTestLibraryHks.mockTestRefs.group}
          >
            {tests
              .filter((test) => test.hasOwnProperty("toc"))
              .map((test) => (
                <CompanySpecificLibraryCards key={test.id} test={test} />
              ))}
          </div>
          {tests.filter((test) => test.hasOwnProperty("toc")).length >= 3 && (
            <RightArrowPagination
              onClick={() => MockTestLibraryHks.scroll("right", "group")}
            />
          )}
        </div>
      )}

      {enabledFeatures.includes("mcq") && tests.length > 0 &&
        tests.some((test) => test.libtype === constants.libTypeIds.MCQ) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">MCQs</p>
            {tests.filter((test) => test.libtype === constants.libTypeIds.MCQ).length >= 3 && (
              <LeftArrowPagination
                onClick={() => MockTestLibraryHks.scroll("left", "mcq")}
              />
            )}
            <div
              className="mcqMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.mcq}
            >
              {tests
                .filter((test) => test.libtype === constants.libTypeIds.MCQ)
                .map((test) => (
                  <CompanySpecificLibraryCards key={test.id} test={test} />
                ))}
            </div>
            {tests.filter((test) => test.libtype === constants.libTypeIds.MCQ).length >= 3 && (
              <RightArrowPagination
                onClick={() => MockTestLibraryHks.scroll("right", "mcq")}
              />
            )}
          </div>
        )}

      {enabledFeatures.includes("descriptive") && tests.length > 0 &&
        tests.some(
          (test) =>
            !test.aiMode &&
            !test.videoqn &&
            !test.autoeval &&
            test.libtype === constants.libTypeIds.DESCRIPTIVE
        ) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">Descriptive</p>
            {tests.filter(
              (test) =>
                !test.aiMode &&
                !test.videoqn &&
                !test.autoeval &&
                test.libtype === constants.libTypeIds.DESCRIPTIVE
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() => MockTestLibraryHks.scroll("left", "descriptive")}
              />
            )}
            <div
              className="descMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.descriptive}
            >
              {tests
                .filter(
                  (test) =>
                    !test.aiMode &&
                    !test.videoqn &&
                    !test.autoeval &&
                    test.libtype === constants.libTypeIds.DESCRIPTIVE
                )
                .map((test) => (
                  <CompanySpecificLibraryCards key={test.id} test={test} />
                ))}
            </div>
            {tests.filter(
              (test) =>
                !test.aiMode &&
                !test.videoqn &&
                !test.autoeval &&
                test.libtype === constants.libTypeIds.DESCRIPTIVE
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("right", "descriptive")
                }
              />
            )}
          </div>
        )}

      {enabledFeatures.includes("coding_challenge_test") && tests.length > 0 &&
        tests.some((test) => test.libtype === constants.libTypeIds.CODING_CHALLENGE) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">Coding Challenges</p>
            {tests.filter(
              (test) => test.libtype === constants.libTypeIds.CODING_CHALLENGE
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("left", "codingChallenge")
                }
              />
            )}
            <div
              className="ccMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.codingChallenge}
            >
              {tests
                .filter((test) =>
                  test.libtype === constants.libTypeIds.CODING_CHALLENGE
                )
                .map((test) => (
                  <CompanySpecificLibraryCards key={test.id} test={test} />
                ))}
            </div>
            {tests.filter(
              (test) => test.libtype === constants.libTypeIds.CODING_CHALLENGE
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("right", "codingChallenge")
                }
              />
            )}
          </div>
        )}

      {enabledFeatures.includes("coding_snippet") && tests.length > 0 &&
        tests.some((test) => test.libtype === constants.libTypeIds.CODING_SNIPPET) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">Coding Snippet</p>
            {tests.filter(
              (test) => test.libtype === constants.libTypeIds.CODING_SNIPPET
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("left", "codingSnippet")
                }
              />
            )}
            <div
              className="csMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.codingSnippet}
            >
              {tests
                .filter((test) => test.libtype === constants.libTypeIds.CODING_SNIPPET)
                .map((test) => (
                  <CompanySpecificLibraryCards key={test.id} test={test} />
                ))}
            </div>
            {tests.filter(
              (test) => test.libtype === constants.libTypeIds.CODING_SNIPPET
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("right", "codingSnippet")
                }
              />
            )}
          </div>
        )}

      {enabledFeatures.includes("video_test") && tests.length > 0 &&
        tests.some(
          (test) =>
            test.libtype === constants.libTypeIds.DESCRIPTIVE && test.videoqn
        ) && (
          <div className="mockTestsCardHolder">
            <p className="mockTestHeads">Video Assessment</p>
            {tests.filter(
              (test) =>
                test.videoqn &&
                test.libtype === constants.libTypeIds.DESCRIPTIVE
            ).length >= 3 && (
              <LeftArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("left", "videoAssessment")
                }
              />
            )}
            <div
              className="vaMockTestContainer"
              ref={MockTestLibraryHks.mockTestRefs.videoAssessment}
            >
              {tests
                .filter(
                  (test) =>
                    test.videoqn &&
                    test.libtype === constants.libTypeIds.DESCRIPTIVE
                )
                .map((test) => (
                  <CompanySpecificLibraryCards key={test.id} test={test} />
                ))}
            </div>
            {tests.filter(
              (test) =>
                test.videoqn &&
                test.libtype === constants.libTypeIds.DESCRIPTIVE
            ).length >= 3 && (
              <RightArrowPagination
                onClick={() =>
                  MockTestLibraryHks.scroll("right", "videoAssessment")
                }
              />
            )}
          </div>
        )}
    </div>
  );
}
